export const isEntity = (id = ""): boolean => {
  const splitString = id?.split(":");
  return splitString?.[0] !== "i_userService";
};
